import { isCapacitor } from '@ui/utils/capacitor';
import { useCurrentUser } from '../apis/user/use';
import { useEffect } from 'react';
import { Intercom } from '@capacitor-community/intercom';
import { PushNotifications } from '@capacitor/push-notifications';

let pushInit = false;

export function useInitIntercom() {
  const user = useCurrentUser();

  useEffect(() => {
    async function init() {
      if (!user) return;
      const { userId, email, intercomHash } = user;

      if (isCapacitor && userId && intercomHash) {
        try {
          await Intercom.registerIdentifiedUser({ userId, email });
          await Intercom.setUserHash({ hmac: intercomHash });
        } catch (err) {
          console.error('Push notification Intercom init error:', err);
        }

        if (!pushInit) {
          pushInit = true;

          let permStatus = await PushNotifications.checkPermissions();
          if (permStatus.receive !== 'granted') {
            permStatus = await PushNotifications.requestPermissions();
          }

          if (permStatus.receive === 'granted') {
            await PushNotifications.register();

            PushNotifications.addListener('registration', async (token) => {
              try {
                if (token?.value) {
                  await Intercom.sendPushTokenToIntercom({
                    value: token.value,
                  });
                } else {
                  console.warn('No FCM token received');
                }
              } catch (err) {
                console.error('Failed to send token to Intercom:', err);
              }
            });
            PushNotifications.addListener(
              'pushNotificationReceived',
              async (notification) => {
                try {
                  await Intercom.receivePush(notification.data);
                } catch (err) {
                  console.error('Failed to handle Intercom push:', err);
                }
              },
            );

            PushNotifications.addListener('registrationError', (error) => {
              console.error('Push registration error:', error);
            });
          }
        }
      } else if (window.intercomSettings) {
        window.intercomSettings.user_hash = intercomHash;
      }
    }

    init();
  }, [user]);
}
